import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { take, tap, catchError } from 'rxjs/operators';
import { AAGUID } from '@interticket/core';
import { environment } from '@env';
import { IMediaSource } from '@core/interfaces/media/media-source.interface';
import { StoreService } from '../store/store.service';
import { ILivestreamStatus } from '@core/interfaces/media/livestream-status.interface';

@Injectable()
export class MediaService {

  private readonly cdnBaseUrl: string = 'https://cdn.stx.interticket.com/images';
  private readonly streamBaseUrl: string = `${environment.serviceUrl}/v2/media/stream`;

  constructor(
    private mediaSourceService: IMediaSource,
    private storeService: StoreService
  ) { }

  /**
   * Returns image view url
   *
   * @param {AAGUID} [guid]
   */
  getImageUrl(guid?: AAGUID): string {
    return guid ? `${this.cdnBaseUrl}/${guid}` : '';
  }

  /**
   * Returns stream source url
   *
   * @param {AAGUID} [eventId]
   */
  getStreamUrl(eventId?: AAGUID): string {
    return eventId ? `${this.streamBaseUrl}/${eventId}.m3u8?access_token=${this.storeService?.authToken.access_token}` : '';
  }

  getLivestreamStatus(eventId: AAGUID): Observable<ILivestreamStatus> {
    return this.mediaSourceService.getLivestreamStatus(eventId);
  }

  getStreamableEvents(): Observable<AAGUID[]> {
    return this.mediaSourceService.getStreamableEvents()
      .pipe(
        take(1),
        catchError(() => of([])),
        tap((events: AAGUID[]) => this.storeService.streamableEvents = events)
      );
  }

}
